import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/home-popup/register-coupon.png")